import { CSSProperties } from 'react';

import Image from 'next/image';
import { ReactPlayerProps } from 'react-player';

import { PlayVideoModalIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import ImageWithFallback from '@components/utils/ImageWithFallback';
import VideoPlayer from '@components/ui/video-player';
import { HotelDetailVideoViewModel } from '@api/v3';

import { HotelGalleryVideoItem } from '.';
import { PlayIconWrapper, VideoThumbnailWrapper, VideoWrapper } from './style';

type Props = {
  item: HotelGalleryVideoItem | HotelDetailVideoViewModel;
  isFullScreen?: boolean;
  wrapperCSS?: CSSProperties;
};

const DesktopVideoItem = ({ item, isFullScreen, wrapperCSS }: Props) => {
  return (
    <VideoWrapper isFullScreen={isFullScreen} style={wrapperCSS}>
      <VideoPlayer
        url={item.url}
        PlayIcon={
          <CustomIcon icon={PlayVideoModalIcon} width={83} height={66} />
        }
        FallbackComponent={
          <div>
            <ImageWithFallback
              Component={Image}
              src={item.url ?? ''}
              alt={item.description ?? 'setur'}
              width={571}
              height={370}
              style={{ objectFit: 'contain' }}
            />
          </div>
        }
      />
    </VideoWrapper>
  );
};

export default DesktopVideoItem;

type ThumbnailProps = {
  item: HotelGalleryVideoItem;
  wrapperCSS?: CSSProperties;
  video: HotelDetailVideoViewModel;
} & ReactPlayerProps;

export const VideoThumbnail = ({ item, wrapperCSS, video }: ThumbnailProps) => {
  return (
    <VideoThumbnailWrapper style={wrapperCSS}>
      <ImageWithFallback
        Component={Image}
        src={video.coverImage ?? ''}
        alt={item.description ?? 'setur'}
        width={142}
        height={70}
        style={{ objectFit: 'cover' }}
      />
      <PlayIconWrapper>
        <CustomIcon icon={PlayVideoModalIcon} fontSize={40} />
      </PlayIconWrapper>
    </VideoThumbnailWrapper>
  );
};
